// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1nYsd","colCheckbox":"styles_colCheckbox__3LjJP"};